export default {
    page: function() {
        this.loadCarts()
    },
}
